export interface PartParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  description: string;
  projectId: string;
  type: PartType;
}

export interface PartData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  description: string;
  projectId: string;
  type: PartType;
}

export type PartCreateData = Omit<PartData, 'id' | 'createdAt' | 'updatedAt'>;

export enum PartType {
  TEMPLATE = 'template',
  PART_INSTANCE = 'part_instance',
}
